import Vue from 'vue'
const ShortKey = require('vue-shortkey')

/**
 * @see [v-shortkey](https://github.com/iFgR/vue-shortkey)
 */
Vue.use(ShortKey, { prevent: ['.no-v-short-key'] })

export default ShortKey
